<div ngModelGroup="comboParticipacao-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="{{fxFlexOffset}}">
    <combo-modulo-reunioes #comboParticipacao 
                       nome="reuniao-{{data}}" 
                       [itens]="dados" 
                       [itemDescricao]="campoPesquisavel"
                       itemId="id"
                       [showDisplayId]="showDisplayId" 
                       label="{{label}}"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Escolha..."
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-modulo-reunioes>
</div>

